import { FC, useEffect, useState } from 'react'
import { isFulfilled } from '@reduxjs/toolkit'
import { FormikHelpers } from 'formik'

import CustomPopup from '../../UI/Popup'
import CustomButton from '../../UI/Buttons/CustomButton'
import UploadImage from '../../UploadCropImage'
import GeneralForm from '../../Form'
import TextInput from '../../UI/Inputs/TextInput'
import SelectInput from '../../UI/Inputs/SelectInput'

import { useDispatch, useSelector } from '../../../store'
import { toggleAddProjectModalAction } from '../../../store/application/slice'
import { createProjectThunk } from '../../../store/project/thunks'
import { getTimezonesThunk } from '../../../store/application/thunks'

import { TCreateProjectFormValues } from '../../../models/form'

import './AddProjectModal.scss'
import { generatePath } from 'react-router'
import { AUTH_ROUTE } from '../../../pages/App/routes'
import { push } from 'connected-react-router'
import { chooseProjectAction } from '../../../store/project/slice'
import { setUserRoleAction } from '../../../store/auth/slice'

const AddProjectModal: FC<any> = () => {
  const dispatch = useDispatch()
  const close = () => {
    dispatch(toggleAddProjectModalAction())
  }

  const [image, setImage] = useState<any>(null)
  const { timezones, inProgress, isOpenAddProject } = useSelector((state) => ({
    timezones: state.app.timezones.map((zone: any) => ({
      label: zone.split('/').join(' - '),
      value: zone
    })),
    inProgress: state.agency.inProgress,
    isOpenAddProject: state.app.isOpenAddProject
  }))

  const setUpForm = {
    initialValues: { name: '', timezone: '' },
    validation: 'project',
    onSubmit: async (
      values: TCreateProjectFormValues,
      actions: FormikHelpers<TCreateProjectFormValues>
    ) => {
      const data = new FormData()
      data.append('name', values.name)
      data.append('timezone', values.timezone)
      if (image) {
        data.append('image', image)
      }

      const createProjectResponse = await dispatch(createProjectThunk(data))

      if (isFulfilled(createProjectResponse)) {
        dispatch(setUserRoleAction(createProjectResponse.payload.role))
        dispatch(chooseProjectAction({ ...createProjectResponse.payload, socials: [] }))
        dispatch(
          push(
            generatePath(AUTH_ROUTE.TEAM, {
              projectId: createProjectResponse.payload.id
            })
          )
        )
        const projectsSideBarContainer = document.querySelector(
          '.project-navigation__change-customer'
        )!
        const { height } = projectsSideBarContainer.getBoundingClientRect()
        projectsSideBarContainer.scrollTo(0, height)
        close()
      }
    }
  }

  useEffect(() => {
    const fetchTimezones = async () => await dispatch(getTimezonesThunk())
    fetchTimezones()
  }, [dispatch])

  return (
    <CustomPopup
      open={isOpenAddProject}
      buttonClose={close}
      closeOnDocumentClick={false}
      className='add-project'
    >
      <div className='add-project__wrapper'>
        <div className='add-project__header'>Add New Project</div>
        <UploadImage setImage={setImage} imageBorder='rounded-square' />
        <GeneralForm {...setUpForm}>
          <TextInput label='Project name' name='name' placeholder='Enter project name' />
          <SelectInput
            label='Project name'
            name='timezone'
            placeholder='Type to find your region'
            options={timezones}
          />
          <div className='add-project__actions'>
            <CustomButton onClick={close} type='button' button='secondary'>
              Cancel
            </CustomButton>
            <CustomButton inProgress={inProgress} button='primary' type='submit'>
              Add
            </CustomButton>
          </div>
        </GeneralForm>
      </div>
    </CustomPopup>
  )
}

export default AddProjectModal
